<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4">
<!--          <template v-slot:left>-->
          <template #start>
            <div style="font-size: 1.4em;" class="p-mr-3" >{{ $t('Orders') }}</div>
          </template>
          <template #end>
            <SearchInput :disabled="dataTableIsLoading" @change-processed-search-value="changeProcessedSearchValue" v-model="searchData" @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <Spinner v-if="isLoading"/>
        <div v-else-if="!isLoading && !items?.length" class="no-data-block">{{ $t('No data available') }}</div>
        <template v-else>
          <DesktopDataTable v-for="(date, index) of dates"
                            v-show="datedItems[index].length"
                            :key="index"
                            class="datatable"
                            :dataTableIsLoading="dataTableIsLoading"
                            :tableName="parseDate(date)"
                            :itemsArrayIsEmpty="itemsArrayIsEmpty"
                            :sort="sort"
                            :striped="false"
                            :highlightTable="isTableHightlight(date)"
                            :showSearchInput="false"
                            :actionButtonsCount="actionButtonsCount"
                            :headers="[
                {name: 'start', title: $t('Start'), width: '4%', sortable: false},
                {name: 'number', title: $t('Number'), minWidth: '94px', sortable: false},
                {name: 'customer', title: $t('Customer'), width: '12%', sortable: false},
                {name: 'order', title: $t('Name'), width: '17%', sortable: false},
                {name: 'time', title: $t('Time'), width: '8%', sortable: false},
                {name: 'car', title: $store.getters.isForkliftTenant ? $t('Equipment') : $t('Car'), width: '20%', sortable: false},
                {name: 'area_id', title: $t('workstation'), width: '8%', sortable: false},
                {name: 'responsible', title: null, width: '4%', sortable: false},
                {name: 'masters', title: $t('techniciansLabel'), width: '12%', sortable: false},
                {name: 'state', title: $t('Status'), width: '10%', sortable: false},
            ]">
            <template v-slot:body>
              <template v-for="(item, index) of datedItems[index]" :key="index">
                <tr :class="{'updated-item': isItemUpdated(item.id)}">
                  <td :class="{'warning-color':  (+new Date() > +new Date(item.start * 1000)) && item.state === 1 }">{{ formatTime(item.start) }}</td>
                  <td>
                    <div>{{ item.number }}</div>
                  </td>
                  <td>
                    <div v-if="item.customer">
                      <span v-if="item.customer.type === constants.userTypes.legal_entity && item.customer.company_name">{{ item.customer.company_name }} </span>
                      <span v-else>{{ item.customer.first_name || '' }} {{ item.customer.last_name || '' }} </span>
                    </div>
                  </td>
                  <td>
                    <div class="p-d-flex p-ai-center p-flex-wrap">
                      <a href="#" @click.prevent="toggleShowPositionTable(item)" class="p-mr-2">
                        <i style="font-size: 0.9em" class="p-mr-1 pi" :class="item.showPositionsTable ? 'pi-minus': 'pi-plus'"></i>
                        <span class="text">{{ item.name || item.number }}</span>
                      </a>
                    </div>
                    <div class="table-small-text">
                      <span :class="{'created-by-customer':item.source === 2}">
                        {{ formatBy(item.created_at, item.creator) }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <span v-if="item.time && +item.time !== 0">{{ formatHoursAndMinutes(item.time) }}</span>
                    <i v-else class="ti-minus"></i>
                  </td>

                  <td>
                    <span v-if="item.car">
                      <i v-if="!$store.getters.isForkliftTenant" class="ti-car p-mr-1"/>

                      <span class="p-mr-1">
                        {{ carDisplayName(item.car) }}
                      </span>

                      <div class="table-small-text p-d-flex p-ai-center">
                        <div>
                          <span v-if="carIdentifier(item.car)">{{ carIdentifier(item.car) }}</span>
                          <i v-else class="ti-minus"/>
                          <span v-if="item.car.year">, {{ item.car.year }}</span>
                        </div>

                       <CarDataLink v-if="item.car.plate_number"
                                    :plateNumber="item.car.plate_number"
                                    :showOnlyIcon="true"/>
                      </div>
                    </span>
                    <i v-else class="ti-minus"/>
                  </td>

                  <td>
                    <span v-if="item.area?.name">{{ item.area.name }}</span>
                    <i v-else class="ti-minus"></i>
                  </td>

                  <td class="avatar-td">
                    <AvatarsCell :responsible="item.responsible"/>
                  </td>

                  <td class="avatar-td">
                    <AvatarsCell :masters="item.masters"/>
                  </td>
                  <td>
                    <OrderStateButton :item="item"/>
                  </td>
                  <td>
                    <div class="actions" v-if="item && item.uid">
                      <router-link :to="{ path: `/master-orders/${item.uid}` }"><ViewButton/></router-link>
                    </div>
                  </td>
                </tr>
                <tr v-show="item.showPositionsTable" class="table-opened-info">
                  <td colspan="20" class="table-opened-info__cell">
                    <PositionsTable :item="item"
                                    :isSpoilerTable="true"
                                    :showServiceWorkTimeInsteadOfQty="true"
                                    :showFinancialData="false"/>
                  </td>
                </tr>
              </template>
            </template>
          </DesktopDataTable>
        </template>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

			</div>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import OrderStateButton from '@/pages/orders/components/OrderStateButton'
import formatMixins from '@/mixins/formatMixins'
import PositionsTable from '@/components/PositionsTable'
import httpMixins from '@/mixins/httpMixins'
import datatableMixins from '@/mixins/datatableMixins'
import AvatarsCell from "@/components/AvatarsCell";
import settings from "@/settings";
import CarDataLink from "@/pages/vehicles/components/CarDataLink.vue";

export default {
  mixins: [ formatMixins, httpMixins, datatableMixins ],
  components: { OrderStateButton, PositionsTable,AvatarsCell, CarDataLink },
	data() {
		return {
      item: {},
      orderStaffCommentModal: false,
      openedItemsIds: [],
      dates: [],
      datedItems: [],
      fieldsExpand: 'customer,' +
          'creator,' +
          'responsible,' +
          'masters,' +
          'positions,' +
          'positions.service,' +
          'positions.master,' +
          'consumable,' +
          'car,' +
          'area,' +
          // 'recommendation_history,' +
          // 'state_history,' +
          // 'comments_history,' +
          'change_history_counts,' +
          'parentOffer,parentOrder',
      apiLink: 'order/get-employee-orders',
      routePath: '/master-orders',
      sort: {
        column: 'start',
        direction: '',
      },
		}
	},
  watch: {
    '$store.state.updatedOrderId'(orderId) {
      if (!orderId) return

      this.updateOrder(orderId)

      setTimeout(() => {
        this.$store.commit('changeUpdatedOrderId', null)
      }, 100)
    },
  },
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
  },
  methods: {
    getPageData() {
      this.getItems()
    },
    async updateOrder(id) {
      if (!id) return false
      this.updatedItemId = id
      let indexToReplace = this.items?.findIndex(item => item.id === id)
      if (indexToReplace > -1) {
        const itemData = await this.getOrderById(id)
        if (!itemData) return

        this.items[indexToReplace] = itemData
        this.updatedItemId = id
        this.constructOrdersTable()
      }
    },
    isTableHightlight(date) {
      if (!date) return false

      const now = new Date()
      date = new Date(date)
      return date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()
    },
    async getItems(showSpinner = false) {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      this.disableEditButton = true
      if (showSpinner) {
        this.isLoading = true
      }
      const ctrl = this.setController?.('masterOrders')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal,
        })

        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }

          this.constructOrdersTable()
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        this.disableEditButton = false
        if (this._abortors?.masterOrders === ctrl) {
          this._abortors.masterOrders = null
        }
      }
    },
    constructOrdersTable() {
      if (!this.items?.length) return
      let dates = []
      this.items.forEach(item => {
        const date = new Date(item.start * 1000)
        const day = String(date.getDate()).length === 1 ? '0' + String(date.getDate()) : date.getDate()
        const month = String(date.getMonth() + 1).length === 1 ? '0' + String(date.getMonth() + 1) : date.getMonth() + 1
        const year = date.getFullYear()
        const fullDate = `${year}-${month}-${day}`
        if (dates.indexOf(fullDate) === -1) {
          dates.push(fullDate)
        }
      })

      if (this.openedItemsIds.length) {
        this.items.forEach(item => {
          if (this.openedItemsIds.indexOf(item.id) !== -1) {
            item.showPositionsTable = true
          }
        })
      }

      this.dates = dates.sort((a, b) => +new Date(a) - +new Date(b))

      let i = 0
      for (let date of this.dates) {
        this.datedItems[i] = this.items.filter(item => {
          const itemDate = new Date(item.start * 1000)
          return +itemDate.getFullYear() === Number(date.substr(0, 4)) &&
              +itemDate.getMonth() + 1 === Number(date.substr(5, 2)) &&
              +itemDate.getDate() === Number(date.substr(8, 2))
        }).sort((a, b) => a.start - b.start)
        i++
      }
    },
    parseDate(date) {
      const parsedDate = new Date(date)
      const parsedDateYear = parsedDate.getFullYear()
      const parsedDateMonth = parsedDate.getMonth()
      const parsedDateDay = parsedDate.getDate()
      const parsedDay = new Date(parsedDateYear, parsedDateMonth, parsedDateDay)

      const todayDate = new Date()
      const todayYear = todayDate.getFullYear()
      const todayMonth = todayDate.getMonth()
      const todayDay = todayDate.getDate()
      const today = new Date(todayYear, todayMonth, todayDay)

      const yesterday = new Date(todayYear, todayMonth, todayDay - 1)
      const tomorrow = new Date(todayYear, todayMonth, todayDay + 1)

      let day = ''

      if (+parsedDay === +today) {
        day = ' - ' + this.$t('Today')
      } else if (+parsedDay === +yesterday) {
        day = ' - ' + this.$t('Yesterday')
      } else if (+parsedDay === +tomorrow) {
        day = ' - ' +  this.$t('Tomorrow')
      }

      return this.formatDay(parsedDate / 1000) + ' ' + day
    },
	},
  computed: {
    actionButtonsCount() {
      return 1
    },
  }
}
</script>

<style scoped lang="scss">
.no-data-block {
  padding: 8vh 0;
  //height: 100%;
  text-align: center;
}

.table-opened-info__cell {
  padding: 0 !important;
  border-bottom: none !important;
}
</style>